/** @format */

import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import 'firebase/storage';

let config;

const devConfig = {
  apiKey: 'AIzaSyC_0Djgy4Y4F7rTuOh3GXIm3wJDC1C7inw',
  authDomain: 'autoricambi-gest.firebaseapp.com',
  databaseURL: 'https://autoricambi-gest.firebaseio.com',
  projectId: 'autoricambi-gest',
  storageBucket: 'autoricambi-gest.appspot.com',
  messagingSenderId: '809348550825',
};

const betaConfig = {
  apiKey: 'AIzaSyCon5E57AJDH4MPnUmltTsZ7JnlTzET6Go',
  authDomain: 'autoricambi-gest-beta.firebaseapp.com',
  databaseURL: 'https://autoricambi-gest-beta.firebaseio.com',
  projectId: 'autoricambi-gest-beta',
  storageBucket: 'autoricambi-gest-beta.appspot.com',
  messagingSenderId: '1086117392335',
};

if (process.env.NODE_ENV === 'production') {
  config = betaConfig;
} else {
  config = devConfig;
}

firebase.initializeApp(config);

export const auth = firebase.auth();
export const storage = firebase.storage();

export default firebase.database();
